/**
 * Adds active class to the anchor link of the current section in view.
 * @function sectionAnchors
 * @returns {void}
 */
export function sectionAnchors() {
    const anchors = document.querySelectorAll(".nav-anchors .anchor");
    const sections = document.querySelectorAll("section.cont");

    if (sections.length) {
        window.addEventListener("scroll", () => {
            let currentId = null;
            const scrollPosition = pageYOffset;

            sections.forEach((section) => {
                const sectionTop = section.offsetTop;
                if (scrollPosition >= sectionTop - 60) {
                    currentId = section.getAttribute("id");
                }
            });

            anchors.forEach((anchor) => {
                anchor.classList.remove("active");
                if (anchor.getAttribute("href") === `#${currentId}`) {
                    anchor.classList.add("active");
                }
            });
        });
    }
}
